import {zEnvVariablesPublic} from '../../utils/env'
import {z} from 'zod'

export const zEnvVariablesServer = z
  .object({
    R2_URL: z.string().optional(),
    R2_API_TOKEN: z.string().optional(),
    R2_ZONE_ID: z.string().optional(),
    OPENAI_API_KEY: z.string().optional(),
    /** the private supabase url for the server */
    SUPABASE_URL: z.string().optional(),
    SUPABASE_SERVICE_KEY: z.string().optional(),
    POSTMARK_API_KEY: z.string().optional(),
    SMTP_URL: z.string().optional(),
    ADMIN_EMAIL: z.string().optional(),
    LICENSE_KEY_PUBLIC: z.string().optional(),
    LICENSE_KEY_PRIVATE: z.string().optional(),
    GEMINI_API_KEY: z.string().optional(),
    LICENSE_TOKEN: z.string().optional(),
    STRIPE_SECRET_KEY: z.string().optional(),
    STRIPE_WEBHOOK_SECRET: z.string().optional(),
    STRIPE_WEBHOOK_SECRET_FALLBACK: z.string().optional(),
    SLACK_BOT_TOKEN: z.string().optional(),
    MONDAY_TOKEN: z.string().optional()
  })
  .merge(zEnvVariablesPublic.pick({NEXT_PUBLIC_SUPABASE_URL: true}))

export const envServer = zEnvVariablesServer.parse(process.env)
